import {
  ResponseData,
  TProductCreatorResponse,
  TProductLiveResponse,
  TProductTrendInfo,
  TProductVideoResponse,
  TShopResponse,
  TProductsCheckShowcaseResponse,
  TProductContainsShowcaseResponse,
  TProductsAddShowcaseResponse,
  TShowcaseAuthUrlResponse,
  TProductsShowcaseAuthUserResponse,
  TSamplesAuthorizedCheckResponse,
  TApplySamplesResponse,
  TProductSkuResponse,
  TSamplesCheckResponse,
  TSamplesAuthorizedCreateResponse,
} from "@/typings";
import { TProductInfo } from "@/typings";
import { fetchYooFindsApi } from "@/utils/fetch";
import { getUri } from "@/utils/url";
import {
  GetProductDetailParams,
  GetProductSKUParams,
  GetProductsCreatorsParams,
  GetProductsLivesParams,
  GetProductsTrendsParams,
  GetProductsVideosParams,
  GetProductsParams,
  GetProductContainsShowcaseParams,
  GetAddShowcaseParams,
  GetSamplesCheckParams,
  GetApplySamplesParams,
  GetSampleAuthorizedCheckParams,
  GetShowcaseAuthUserParams,
  GetShowcaseAuthUrlParams,
  GetProductsCheckShowcaseParams,
  GetSamplesAuthorizedParams,
  GetShopDetailParams,
} from "./interface";

import { encodedCallbackUrl } from "@/utils/url";

/** 没有样品授权，创建样品授权 */
export async function fetchSamplesAuthorizedCreate(
  params: GetSamplesAuthorizedParams
) {
  return fetchYooFindsApi<ResponseData<TSamplesAuthorizedCreateResponse>>(
    getUri("api/samples/authorized/create", params)
  );
}

/** 判断是否样品授权（轮询也使用该接口） */
export async function fetchSamplesAuthorizedCheck(
  params: GetSampleAuthorizedCheckParams
) {
  return fetchYooFindsApi<ResponseData<TSamplesAuthorizedCheckResponse>>(
    getUri(`api/samples/authorized/check`, params.options)
  );
}

/** 提交领样申请 */
export async function fetchApplySamples(params: GetApplySamplesParams) {
  return fetchYooFindsApi<ResponseData<TApplySamplesResponse>>("api/samples", {
    method: "POST",
    body: JSON.stringify(params.options),
  });
}

/** 平台领样校验 */
export async function fetchSamplesCheck(params: GetSamplesCheckParams) {
  return fetchYooFindsApi<ResponseData<TSamplesCheckResponse>>(
    getUri(`api/samples/check`, params)
  );
}
export async function fetchShowcaseAuthUser(params: GetShowcaseAuthUserParams) {
  return await fetchYooFindsApi<
    ResponseData<TProductsShowcaseAuthUserResponse>
  >(getUri(`api/v2/showcase/authUser`, params.options));
}

export async function fetchShowcaseAuthUrl(params: GetShowcaseAuthUrlParams) {
  params.callback = encodedCallbackUrl(params.callback);
  return await fetchYooFindsApi<ResponseData<TShowcaseAuthUrlResponse>>(
    getUri(`api/v2/showcase/authUrl`, params)
  );
}
export async function fetchProductsAddShowcase(params: GetAddShowcaseParams) {
  return await fetchYooFindsApi<ResponseData<TProductsAddShowcaseResponse>>(
    getUri(`api/v2/showcase/add`, params.options)
  );
}
export async function fetchProductsCheckShowcase(
  params: GetProductsCheckShowcaseParams
) {
  return await fetchYooFindsApi<ResponseData<TProductsCheckShowcaseResponse>>(
    getUri("api/v2/showcase/check", params)
  );
}
export async function fetchProductContainsShowcase(
  params: GetProductContainsShowcaseParams
) {
  return await fetchYooFindsApi<ResponseData<TProductContainsShowcaseResponse>>(
    getUri(`api/v2/showcase/contains`, params.options)
  );
}
export async function fetchProductsSKU(params: GetProductsParams) {
  return await fetchYooFindsApi<ResponseData<TProductInfo>>(
    `api/products/${params.product_id}/skus`
  );
}
export async function fetchProductDetail(params: GetProductDetailParams) {
  return await fetchYooFindsApi<ResponseData<TProductInfo>>(
    `api/campaign-products/${params.id}`
  );
}

export async function fetchProductSKU(params: GetProductSKUParams) {
  return await fetchYooFindsApi<ResponseData<TProductSkuResponse>>(
    `api/products/${params.product_id}/skus`
  );
}

export async function fetchShopDetail({ id }: GetShopDetailParams) {
  return await fetchYooFindsApi<ResponseData<TShopResponse>>(`api/shops/${id}`);
}

export async function fetchProductsTrends(params: GetProductsTrendsParams) {
  return await fetchYooFindsApi<ResponseData<TProductTrendInfo[]>>(
    getUri(`api/products/${params.id}/trends`, params.options)
  );
}

export async function fetchProductsVideos(params: GetProductsVideosParams) {
  return await fetchYooFindsApi<ResponseData<TProductVideoResponse>>(
    getUri(`api/v2/products/${params.id}/videos`, params.options)
  );
}

export async function fetchProductsLives(params: GetProductsLivesParams) {
  return await fetchYooFindsApi<ResponseData<TProductLiveResponse>>(
    getUri(`api/v2/products/${params.id}/lives`, params.options)
  );
}

export async function fetchProductsCreators(params: GetProductsCreatorsParams) {
  return await fetchYooFindsApi<ResponseData<TProductCreatorResponse>>(
    getUri(`api/v2/products/${params.id}/creators`, params.options)
  );
}

export async function fetchProductsHighPassRecommend(params?: any) {
  return await fetchYooFindsApi<ResponseData<TProductInfo[]>>(
    getUri("api/v2/products/highPassRecommend", params)
  );
}
